import { DIMENSIONS as METRIC_DIMENSIONS } from "./metrics";
import type { DimensionDef } from "./metrics";

export type DimensionConfig = DimensionDef;
export type DimensionId = DimensionConfig["id"];

export const DIMENSIONS: DimensionConfig[] = METRIC_DIMENSIONS;
